import React, { useEffect } from 'react'
import { Empty } from 'antd';

import axios from './apiClient'


export default function EmptyPage() {
  // useEffect(()=>{
  //   setInterval(()=>{
  //     window.reload();
  //   })
  // },[1000])

  const checkData = async ()=> {
    const res = await axios.get(`/bet/getBettingByTV`);
    if(res.code == 200) {
      window.location.hash = "/"
    }
  }

  useEffect(()=>{
    checkData()
  },[])
  return (
    < Empty 
        description= 'No Odd'
        style={{marginTop : "5rem"}}
    />
  )
}
